module.exports = __webpack_public_path__ + "img/nilaparvata-lugens.868642f8.jpg";